const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

function chartRangeStart() {
  const start = new Date();
  start.setMonth(start.getMonth() - 5);
  start.setDate(1);
  start.setHours(0, 0, 0, 0);
  return start;
}

/** Chart-only admin API fetch (avoids Supabase anon 401 / RLS). */
async function fetchBookingsChartRowsViaApi() {
  const token = localStorage.getItem('developmentexpress_token');
  if (!token) return { rows: [], error: 'Not authenticated' };

  const response = await fetch(`${API_BASE_URL}/api/admin/bookings?limit=1500&offset=0`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    return { rows: [], error: payload.error || `Request failed: ${response.status}` };
  }

  const start = chartRangeStart();
  const rows = (payload.items || [])
    .filter((row) => {
      const raw = row?.created_at;
      if (!raw) return false;
      const dt = new Date(raw);
      return !Number.isNaN(dt.getTime()) && dt >= start;
    })
    .map((row) => ({
      created_at: row.created_at,
      advance_paid: row.advance_paid,
    }));

  return { rows, error: null };
}

/** Dedicated chart fetch — does not use existing admin pagination helpers. */
export async function fetchBookingsChartData() {
  return fetchBookingsChartRowsViaApi();
}

export function aggregateBookingsByMonth(rows) {
  const months = [];
  const now = new Date();
  for (let i = 5; i >= 0; i -= 1) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const key = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    months.push({
      key,
      month: d.toLocaleDateString('en-IN', { month: 'short', year: '2-digit' }),
      revenue: 0,
      bookings: 0,
    });
  }
  const index = Object.fromEntries(months.map((m, i) => [m.key, i]));

  (rows || []).forEach((row) => {
    const raw = row?.created_at;
    if (!raw) return;
    const dt = new Date(raw);
    if (Number.isNaN(dt.getTime())) return;
    const key = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}`;
    const idx = index[key];
    if (idx === undefined) return;
    months[idx].revenue += Number(row.advance_paid || 0);
    months[idx].bookings += 1;
  });

  return months;
}
